import React, { useState, useEffect } from "react";
// import pdf1 from "../images/Transaction-details-Template.pdf"
import DownloadIcon from "../images/download.png"
import ToggleArrow from '../images/toggle-arrow.png'
import loadingImage from '../images/login-shape.png'
import { useLocation } from "react-router-dom";
import callingAPI from "../service"
import moment from 'moment';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Header from "../layout/header";
import HeaderProfile from "../layout/header-profile";
import { setReportData } from "../redux/reducers/reportSlice";
import { setDashboardData } from "../redux/reducers/dashboardSlice";
export default function TransactionDetails() {
    const dispatch = useDispatch();

    const dashboardDetails = useSelector((state) => state.Dashboard);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
    const [toggelTdOne, setToggleTdOne] = useState(1)
    const [loaderFlag, setLoaderFlag] = useState(false)
    const [transactionSummery, setTransactionSummery] = useState([])
    const refreshToken = dashboardDetails.refreshToken;
    const windowHeight = window.innerHeight
    const TableHeight = {
        maxHeight: `${windowHeight - 230}px`
    }
    // const [transactionDetails, setTransactionDetails] = useState([])
    // const [transactionSummeryTotal, setTransactionSummeryTotal] = useState([])
    const location = useLocation();
    var selectedReportStartDate = "";
    var selectedReportEndDate = "";
    var userLogId = ""

    const userId = dashboardDetails.userId
    useEffect(() => {
        dispatch(
            setDashboardData({
                moduleId: 8,
                userlogId: ""
            })
        );
        handleUserLog()
        return () => {
            handleUserLog();
        };
    }, []);

    const handleUserLog = () => {
        const postData = {
            "userId": userId,
            "isApp": "false",
            "moduleId": 8,
            "previousPage": dashboardDetails.previousPage,
            "userSession": refreshToken,
            "userLogId": userLogId
        }
        callingAPI(postData, "user/userLog", 'post')
            .then((response) => {
                const { data } = response;
                if (data.statusCode === 200) {
                    userLogId = data.data.userLogId
                    dispatch(
                        setDashboardData({
                            previousPage: 8,
                        })
                    );
                }
                else {
                    userLogId = ""
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    }

    useEffect(() => {

        if (location.state) {
            // transactionReportList(); // Fetch report if location.state is valid
        }
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, [location.state]);
    const toggleTableTdOne = (index) => {
        if (isMobile) {
            setToggleTdOne(toggelTdOne === index ? null : index)
        }
    }
    useEffect(() => {
        transactionReportList();

    }, [location])
    const transactionReportList = () => {

        const clientId = dashboardDetails.clientid;
        const userId = dashboardDetails.userId
        const transFrom = dashboardDetails.fromDate ? new Date(dashboardDetails.fromDate).toISOString().split('T')[0] : new Date(new Date).toISOString().split('T')[0]
        const transTo = dashboardDetails.toDate ? new Date(dashboardDetails.toDate).toISOString().split('T')[0] : new Date(new Date).toISOString().split('T')[0]
        const postData = {
            "clientId": clientId,
            "fromDate": transFrom,
            "toDate": transTo,
            //"refreshToken": refreshToken,
            "userId": userId

        }
        callingAPI(postData, "reports/getTransaction", 'post')
            .then((response) => {
                const { data } = response;
                console.log("🚀 ~ .then ~ data:", data)
                if (data.statusCode === 200) {
                    dispatch(setReportData({
                        transaction: data.data
                    }))
                    setTransactionSummery(data.data.groupedArray || []);

                    setLoaderFlag(true)
                } else {
                    console.error('Failed to fetch profile details:', data.message);
                }
            })
            .catch((error) => {
                console.error('Error during profile fetch:', error);
            });
    };

    return (
        <>
            <div className="top-outer">
                <div className="heading-outer">
                    <Header />
                    <HeaderProfile />
                </div>
            </div>
            {loaderFlag ?

                <div className="reports-table">
                    {/* <div className="dwnlod-btn-right">
                <a target="_blank" href="/transaction-details-template" className="" ><img src={DownloadIcon} alt="" width={32} /></a>
            </div> */}
                    <h3 className="reports-mainHead">Transaction
                        <span className="date-table-head">({moment(dashboardDetails.reportClickFromDate).format('DD/MM/yyyy')} - {moment(dashboardDetails.reportClickToDate).format('DD/MM/yyyy')})</span></h3>
                    <div className="table-responsive" style={TableHeight}>
                        <table className="table  table-change mb-0">
                            <thead>
                                <tr>
                                    <th style={{ minWidth: '95px', maxWidth: '10%' }}>Tran Date</th>
                                    <th style={{ minWidth: '100px', maxWidth: '10%' }}>Settlement Date</th>
                                    <th style={{ minWidth: '100px', maxWidth: '10%' }}>Buy/Sell Flag</th>
                                    <th style={{ minWidth: '100px', maxWidth: '10%' }}>Long/Short Flag</th>
                                    <th style={{ minWidth: '100px', maxWidth: '10%' }}>Shares</th>
                                    <th style={{ minWidth: '100px', maxWidth: '10%' }}>Avg Price</th>
                                    <th style={{ minWidth: '100px', maxWidth: '10%' }}>Amount</th>
                                    <th style={{ minWidth: '100px', maxWidth: '10%' }}>Balance Shares</th>
                                    <th style={{ minWidth: '100px', maxWidth: '10%' }}>Cost Price</th>
                                    <th style={{ minWidth: '100px', maxWidth: '10%' }}>Cost Value</th>
                                </tr>
                            </thead>
                            {console.log("paginatedTableData111", transactionSummery)}
                            {transactionSummery?.length > 0 ?
                                <tbody>
                                    <>
                                        {transactionSummery?.map((data, index) =>
                                            <tr>
                                                <td colSpan={12} className="p-0 border-0 td-full">
                                                    <table className="table mb-0 table-change">
                                                        <tbody>
                                                            <tr className="td-colors-tr">
                                                                <td colSpan={12} className="td-colors bg-white border-0 table-split-head  moble-thead-change">{data.stockName}
                                                                    <div className="toggle-table"
                                                                        onClick={() => toggleTableTdOne(1)}
                                                                    >
                                                                        <img src={ToggleArrow} width={12} height={6} alt="toggle" className="img-fluid" />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        <tbody className="table-body-border">
                                                            {(isMobile && toggelTdOne === 1) || (!isMobile) ? (
                                                                <>
                                                                    {data.records.map((innnerItem, innerIndex) =>
                                                                        <tr>
                                                                            <td className=" table-split-div" style={{ minWidth: '50px', maxWidth: '50px' }}>
                                                                                <span className="mobile-td-head ">Tran Date</span>
                                                                                {innnerItem.tranDate}</td>
                                                                            <td className=" table-split-div" style={{ minWidth: '70px', maxWidth: '70px' }}>
                                                                                <span className="mobile-td-head">Settlement Date</span>
                                                                                {innnerItem.settlementDate}</td>
                                                                            <td className=" table-split-div" style={{ minWidth: '55px', maxWidth: '55px' }}>
                                                                                <span className="mobile-td-head">Buy/Sell Flag</span>
                                                                                {innnerItem.buySellFlag}</td>
                                                                            <td className=" table-split-div" style={{ minWidth: '65px', maxWidth: '65px' }}>
                                                                                <span className="mobile-td-head">Long/Short Flag</span>
                                                                                {innnerItem.longShortFlag}</td>
                                                                            <td className="text-end table-split-div" style={{ minWidth: '50px', maxWidth: '50px' }}>
                                                                                <span className="mobile-td-head">Shares</span>
                                                                                <span style={{ color: Number(innnerItem.Shares) < 0 ? '#E43740' : 'black' }}>
                                                                                    {Number(innnerItem.Shares) < 0
                                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(innnerItem.Shares)) || 0)})`
                                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(innnerItem.Shares) || 0)}
                                                                                </span>
                                                                            </td>
                                                                            <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                                <span className="mobile-td-head">Avg Price</span>
                                                                                <span style={{ color: Number(innnerItem.avgPrice) < 0 ? '#E43740' : 'black' }}>
                                                                                    {Number(innnerItem.avgPrice) < 0
                                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Math.abs(Number(innnerItem.avgPrice)) || 0)})`
                                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Number(innnerItem.avgPrice) || 0)}
                                                                                </span>
                                                                            </td>
                                                                            <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                                <span className="mobile-td-head">Amount</span>
                                                                                <span style={{ color: Number(innnerItem.amount) < 0 ? '#E43740' : 'black' }}>
                                                                                    {Number(innnerItem.amount) < 0
                                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(innnerItem.amount)) || 0)})`
                                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(innnerItem.amount) || 0)}
                                                                                </span>
                                                                            </td>
                                                                            {/* <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                 <span className="mobile-td-head">Net</span>
                                                                 <span style={{ color: Number(innnerItem.net) < 0 ? '#E43740' : 'black' }}>
                                                                     {Number(innnerItem.net) < 0
                                                                         ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(innnerItem.net)) || 0)})`
                                                                         : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(innnerItem.net     ) || 0)}
                                                                 </span>
                                                             </td>
                                                                 <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                 <span className="mobile-td-head">Realized G/L</span>
                                                                 <span style={{ color: Number(innnerItem.realizedGL) < 0 ? '#E43740' : 'black' }}>
                                                                     {Number(innnerItem.realizedGL) < 0
                                                                         ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(innnerItem.realizedGL)) || 0)})`
                                                                         : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(innnerItem.realizedGL) || 0)}
                                                                 </span>
                                                             </td> */}
                                                                            <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                                <span className="mobile-td-head">Balance Shares</span>
                                                                                <span style={{ color: Number(innnerItem.balanceShares) < 0 ? '#E43740' : 'black' }}>
                                                                                    {Number(innnerItem.balanceShares) < 0
                                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(innnerItem.balanceShares)) || 0)})`
                                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(innnerItem.balanceShares) || 0)}
                                                                                </span>
                                                                            </td>

                                                                            <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                                <span className="mobile-td-head">Cost Price</span>
                                                                                <span style={{ color: Number(innnerItem.costPrice) < 0 ? '#E43740' : 'black' }}>
                                                                                    {Number(innnerItem.costPrice) < 0
                                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Math.abs(Number(innnerItem.costPrice)) || 0)})`
                                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Number(innnerItem.costPrice) || 0)}
                                                                                </span>
                                                                            </td>
                                                                            <td className="text-end table-split-div" style={{ minWidth: '60px', maxWidth: '60px' }}>
                                                                                <span className="mobile-td-head">Cost Value</span>
                                                                                <span style={{ color: Number(innnerItem.costValue) < 0 ? '#E43740' : 'black' }}>
                                                                                    {Number(innnerItem.costValue) < 0
                                                                                        ? `(${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(innnerItem.costValue)) || 0)})`
                                                                                        : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(innnerItem.costValue) || 0)}
                                                                                </span>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </>
                                                            ) : null}
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                </tbody>
                                :
                                <tbody>
                                    <tr style={{ textAlign: "center", padding: "30px 0" }}>
                                        <td colSpan="12" style={{ textAlign: "center", padding: "50px 0", width: "100%" }}>
                                            No Data
                                        </td>
                                    </tr>
                                </tbody>}
                        </table>
                    </div>
                </div> :
                <div className="d-flex justify-content-center align-items-center loading-container">
                    <div className="spinner-container">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <img src={loadingImage} alt="Loading..." className="loading-image" />
                    </div>
                </div>
            }
        </>
    )
}